import { FC, HTMLAttributes, useMemo } from "react";
import clsx from "classnames";
import { useTranslation } from "react-i18next";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyVariant,
  TypographyColor,
} from "../../../constants/typography";
import { StaticImage } from "../StaticImage";
import { Achievement as AchievementType } from "@onmo/graphql/graphql";
import { convertAchievement } from "../../../models/achievement";
import { useStyles } from "./NextTierCard.style";

interface INextTierCardProps {
  newAchievement: AchievementType;
}

export const NextTierCard: FC<
  HTMLAttributes<HTMLDivElement> & INextTierCardProps
> = (props) => {
  const classes = useStyles();
  const { newAchievement, className, ...otherProps } = props;
  const { t } = useTranslation();
  const newFullAchievement = useMemo(() => {
    return convertAchievement(newAchievement);
  }, [newAchievement]);

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <StaticImage
        src={newFullAchievement?.nextTierIcon?.src1x}
        src2x={newFullAchievement?.nextTierIcon?.src2x}
        src3x={newFullAchievement?.nextTierIcon?.src3x}
        className={classes.achieveImg}
      />
      <div>
        <Typography
          variant={TypographyVariant.BodyB4Bold}
          color={TypographyColor.Silver}
        >
          {t("common_NEXT TIER")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Medium}
          className={classes.desc}
        >
          {t(newFullAchievement?.description || "", {
            amount: newFullAchievement.nextTierTarget,
          })}
        </Typography>
      </div>
    </div>
  );
};
